import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import './styles.css';
import List from './List';
import { Context } from '../../../context/AppContext';
import shuffleArray from '../../../utils/shuffleArray';

const PopularIndustries = ({
  title,
  locationSlug,
  data,
  categoryPageLink,
  shuffle,
}) => {
  const {
    media: { tablet, desktop },
  } = useContext(Context);

  const list = useMemo(() => {
    if (shuffle) {
      shuffleArray(data);
    }
    return data;
  }, [data, shuffle]);

  return (
    <div className="Landing__PopularIndustries__root">
      <div
        className={classNames('Landing__PopularIndustries__content', {
          'Landing__PopularIndustries__content--scrollable': desktop || tablet,
        })}
      >
        <h3 className="Landing__PopularIndustries__title">{title}</h3>
        <List
          data={list}
          locationSlug={locationSlug}
          categoryPageLink={categoryPageLink}
          arrows={tablet}
        />
      </div>
    </div>
  );
};

export default PopularIndustries;
